<template>
  <div
    :id="groupId + '-' + itemID"
    class="accordion-item border border-gray-100 mb-4"
    :class="{ 'is-active': item.active }"
  >
    <dt class="accordion-item-title relative">
      <button @click="toggle" class="px-3 py-4 text-left w-full">
        <span class="h5 text-gray-900 uppercase block" v-html="item.title">
        </span>
        <span class="icon icon-chevron-down"></span>
      </button>
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <dd v-if="item.active" class="overflow-hidden  ">
        <div class="pb-3 px-3">
          <div
            v-html="item.content"
            class="wswg wswg-accordion text-gray-600"
          ></div>
          <div
            v-if="
              typeof item.detail !== 'undefined' && item.detail.label.length > 0
            "
            class="bg-gray-50 flex items-center mt-3 p-2"
          >
            <span class="text-gray-600 text-xl">{{ item.detail.label }} </span>
            <div class="flex ml-auto">
              <i
                v-for="n in 3"
                :key="n"
                class="bg-green-100 h-4 rounded-full w-4 mr-2"
                :class="
                  n <= item.detail.value ? 'bg-green-500' : 'bg-green-100'
                "
              ></i>
            </div>
          </div>
        </div>
      </dd>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["item", "multiple", "groupId", "itemID"],
  methods: {
    toggle(event) {
      if (this.multiple) {
        this.item.active = !this.item.active;
      } else {
        this.$parent.$children.forEach((item, index) => {
          if (
            item.$el.id === event.currentTarget.parentElement.parentElement.id
          ) {
            item.item.active = !item.item.active;
          } else {
            item.item.active = false;
          }
        });
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },

    endTransition(el) {
      el.style.height = "";
    },
  },
};
</script>
<style>
.icon-chevron-down {
  display: block;
  position: absolute;
  top: 0;
  right: 1.25rem;
  bottom: 0;
  margin: auto;
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}
.is-active .icon {
  transform: rotate(180deg);
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}

.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
